FNC.sorting.submit = async form => {
    await naja.uiHandler.submitForm(form);
}